
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";   // ⬅️ Add this
// import { overflow } from "html2canvas/dist/types/css/property-descriptors/overflow";

const BookingScreen = () => {
  const [bookingType, setBookingType] = useState(null); // "book" or "schedule"
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    people: "",
    time: "",
    durationMinutes: ""
  });
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [showItemModal, setShowItemModal] = useState(false);
  // const [bookings, setBookings] = useState([]);
  const [currentItemBookingIndex, setCurrentItemBookingIndex] = useState(null);
  const [newItem, setNewItem] = useState("");

  const [bookings, setBookings] = useState([]);
  const [waitingList, setWaitingList] = useState([]);

  // combined list
  const allBookings = [...bookings, ...waitingList];

  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [bookingData, setBookingData] = useState({
    customerName: "",
    customerPhone: "",
    numberOfPeople: "",
    duration: "",
    bookingDate: "",   // new field
    startTime: "",     // new field
  });



  const handleBookingChange = (e) => {
    setBookingData({ ...bookingData, [e.target.name]: e.target.value });
  };

  const handleBookingConfirm = async () => {
    setTimeout(() => {
          window.location.reload();
        }, 1000);
    try {
      const userId = localStorage.getItem("userId");
      const vendorId = localStorage.getItem("vendorId");
      const token = localStorage.getItem("authToken"); // existing token, if any

      if (!userId || !vendorId) {
        alert("User or Vendor ID not found");
        return;
      }
     
      // Append :00 to make it HH:mm:ss
      const formattedStartTime = bookingData.startTime
        ? bookingData.startTime.length === 5
          ? bookingData.startTime + ":00"
          : bookingData.startTime
        : "11:00:00"; // default

      const requestBody = {
        id: 0,
        userId: parseInt(userId, 10),
        startTime: formattedStartTime,
        durationMinutes: 45,
        phoneNumber: bookingData.customerPhone,
        guestName: bookingData.customerName,
        bookingDate: bookingData.bookingDate,
        capacity: parseInt(bookingData.numberOfPeople, 10),
      };

      const response = await fetch(
        ` https://backend.maamaas.com/food/api/seatingdetails/shedule/advance/booking/${userId}/${vendorId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}), // include token if exists
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok) {
        const contentType = response.headers.get("content-type");
        let errorText;
        if (contentType && contentType.includes("application/json")) {
          const errorJson = await response.json();
          errorText = errorJson.message || JSON.stringify(errorJson);
        } else {
          errorText = await response.text();
        }
        throw new Error(errorText || "Failed to schedule booking");
      }

      // Handle successful response
      let result;
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        result = await response.json();
      } else {
        result = await response.text();
      }

      console.log("Booking confirmed", result);

      // ✅ Store authToken if API returns one
      if (result.authToken) {
        localStorage.setItem("authToken", result.authToken);
        console.log("Auth token stored in localStorage");
      }

      // alert("Booking scheduled successfully!");

      // Close modal and reset form
      setIsBookingOpen(false);
      setBookingData({
        customerName: "",
        customerPhone: "",
        numberOfPeople: "",
        duration: "",
        bookingDate: "",
        startTime: "",
      });

    } catch (error) {
      console.error("Error scheduling booking:", error);
      alert("Error scheduling booking: " + error.message);
    }
  };

  const handleArrival = async (index, id) => {
    try {
      const token = localStorage.getItem("authToken"); // get authToken

      // Call the PUT API with Authorization header
      const response = await fetch(
        ` https://backend.maamaas.com/food/api/seatingdetails/seating-details/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify({ arrivalStatus: "ARRIVED" }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update arrival status");
      }

      // Fetch the updated booking
      const updatedBooking = await fetch(
        ` https://backend.maamaas.com/food/api/seatingdetails/get/${id}`,
        {
          headers: {
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      ).then((res) => res.json());

      // Update local state
      const newBookings = [...bookings];
      newBookings[index] = updatedBooking;
      setBookings(newBookings);
      // alert("Arrival status updated successfully!");
    } catch (error) {
      console.error(error);
      alert("Error updating arrival status");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userId = localStorage.getItem("userId") || 1;
        const token = localStorage.getItem("authToken");

        const bookingsRes = await axios.get(
          ` https://backend.maamaas.com/food/api/seatingdetails/get/by/${userId}`,
          { headers: token ? { Authorization: `Bearer ${token}` } : {} }
        );

        const waitingRes = await axios.get(
          ` https://backend.maamaas.com/food/api/seatingdetails/waiting/user/${userId}`,
          { headers: token ? { Authorization: `Bearer ${token}` } : {} }
        );

        console.log("Bookings API response:", bookingsRes.data);
        console.log("Waiting API response:", waitingRes.data);

        // ⚡ Adjust depending on API structure
        setBookings(Array.isArray(bookingsRes.data) ? bookingsRes.data : bookingsRes.data.bookings || []);
        setWaitingList(Array.isArray(waitingRes.data) ? waitingRes.data : waitingRes.data.waiting || []);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);


  const handleOpenBookingModal = (type) => {
    
    setBookingType(type);
    setFormData({ name: "", phone: "", people: "", date: "", time: "" });
    setShowBookingModal(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleConfirmBooking = async () => {
    setTimeout(() => {
          window.location.reload();
        }, 1000);
    try {
      const userId = localStorage.getItem("userId") || 1; // fallback to 1
      const vendorId = localStorage.getItem("vendorId") || 1; // fallback to 1
      const authToken = localStorage.getItem("authToken"); // ✅ get token from localStorage

      if (!authToken) {
        alert("No auth token found. Please log in again.");
        return;
      }

      const url = ` https://backend.maamaas.com/food/api/seatingdetails/booknow/${userId}/${vendorId}`;

      const params = {
        capacity: parseInt(formData.people),
        guestName: formData.name,
        phoneNumber: formData.phone,
        durationMinutes: 45,
      };

      // ✅ Send POST request with Authorization header
      const response = await axios.post(url, null, {
        params,
        headers: {
          Authorization: `Bearer ${authToken}`, // include the token
          "Content-Type": "application/json",
        },
      });

      console.log("Response:", response.data);
      // alert("Booking confirmed successfully!");
      setShowBookingModal(false);
    } catch (error) {
      console.error("Error booking:", error);
      alert("Booking failed. Try again.");
    }
  };




  const handleOpenItemModal = (index) => {
    setCurrentItemBookingIndex(index);
    setShowItemModal(true);
    setNewItem(false);
  };

  const handleAddItem = () => {
    if (!newItem.trim()) return;
    const updatedBookings = [...bookings];
    updatedBookings[currentItemBookingIndex].items.push(newItem.trim());
    setBookings(updatedBookings);
    setNewItem("");
  };

  const handleRemoveItem = (index) => {
    const updatedBookings = [...bookings];
    updatedBookings[currentItemBookingIndex].items.splice(index, 1);
    setBookings(updatedBookings);
  };

  return (
    <div style={styles.container}>
      <div style={styles.buttonWrapper}>
        <button style={styles.button} onClick={() => handleOpenBookingModal("book")}>
          Book Now
        </button>
        <button style={styles.button} onClick={() => setIsBookingOpen(true)}>
          Schedule Booking
        </button>
      </div>

      <div style={{ overflowX: "auto",height:"80vh",scrollbarWidth:"" }}>

        <table style={styles.table}>
          <thead>
            <tr>
              <th style={tableHeaderStyle}>S.No</th>
              <th style={tableHeaderStyle}>Name</th>
              <th style={tableHeaderStyle}>Phone</th>
              <th style={tableHeaderStyle}>People</th>
              <th style={tableHeaderStyle}>Type</th>
              <th style={tableHeaderStyle}>Time</th>
              <th style={tableHeaderStyle}>Date</th>
              <th style={tableHeaderStyle}>Duration</th>
              <th style={tableHeaderStyle}>Status</th>
              <th style={tableHeaderStyle}>Items</th>
            </tr>
          </thead>
          <tbody>
            {[...bookings, ...waitingList].map((b, index) => (
              <tr key={b.id}>
                <td style={tableCellStyle}>{index + 1}</td>
                <td style={tableCellStyle}>{b.guestName}</td>
                <td style={tableCellStyle}>{b.phoneNumber}</td>
                <td style={tableCellStyle}>{b.
                  capacity
                }</td>
                <td style={tableCellStyle}>{b.
                  types
                }</td>
                <td style={tableCellStyle}>
                  {b.requestTime} {b.startTime ? `  ${b.startTime}` : ""}
                </td>

                <td style={tableCellStyle}>
                  {b.bookingDate
                    ? new Date(b.bookingDate).toLocaleDateString("en-GB") // formats as dd/mm/yyyy
                    : "-"
                  }
                </td>

                <td style={tableCellStyle}>{b.time || b.durationMinutes || "-"} Minutes </td>
                <td style={tableCellStyle}>
                  {b.code ? `Table ${b.code}` : "Waiting List"}
                </td>
                <td style={tableCellStyle}>
                  {b.code && b.code !== "PENDING" ? (
                    <>
                      {(!b.items || b.items.length === 0) ? (
                        <>
                          {b.arrivalStatus === "NOT_ARRIVED" ? (
                            <button
                              onClick={() => {
                                handleArrival(index, b.id);
                                localStorage.setItem("seatingId", b.seatingId); // ✅ store seatingId
                              }}
                              style={{ ...styles.itemBtn, color: "#fff", cursor: "pointer" }}
                            >
                              Arrived
                            </button>
                          ) : (
                            <Link
                              to="/tablemenu"
                              onClick={() => localStorage.setItem("seatingId", b.seatingId)} // ✅ store seatingId
                              style={{ ...styles.itemBtn, color: "#fff", cursor: "pointer", textDecoration: "none" }}
                            >
                              Add Items
                            </Link>
                          )}
                        </>
                      ) : (
                        <ul>
                          {b.items.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      )}
                    </>
                  ) : (
                    "WATTING LIST" // show "-" if PENDING or no code all the data of the code 
                  )}
                </td>
              </tr>
            ))}
          </tbody>

        </table>
      </div>


      {isBookingOpen && (
        <div style={styles.overlay}>
          <div style={styles.popup}>
            <h3>Schedule Now</h3>

            <input
              type="text"
              name="customerName"
              placeholder="Name"
              value={bookingData.customerName}
              onChange={handleBookingChange}
              style={styles.input}
            />

            <input
              type="text"
              name="customerPhone"
              placeholder="Phone"
              value={bookingData.customerPhone}
              onChange={handleBookingChange}
              style={styles.input}
            />

            <input
              type="number"
              name="numberOfPeople"
              placeholder="No. of People"
              value={bookingData.numberOfPeople}
              onChange={handleBookingChange}
              style={styles.input}
            />

            {/* Date Picker */}
            <input
              type="date"
              name="bookingDate"
              value={bookingData.bookingDate}
              onChange={handleBookingChange}
              style={styles.input}
            />

            {/* Time Picker */}
            <input
              type="time"
              name="startTime"
              value={bookingData.startTime}
              onChange={handleBookingChange}
              style={styles.input}
            />

            <div style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "20px",      // space between buttons
              marginTop: "20px"
            }}>
              <button style={styles.confirmButton} onClick={handleBookingConfirm}>
                Confirm
              </button>

              <button
                style={styles.cancelButton}
                onClick={() => setIsBookingOpen(false)}
              >
                Cancel
              </button>
            </div>

          </div>
        </div>
      )}




      {showBookingModal && (
        <div style={styles.overlay}>
          <div style={styles.popup}>
            <h3>Book Now</h3>
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleInputChange}
              style={styles.input}
            />
            <input
              type="text"
              name="phone"
              placeholder="Phone"
              value={formData.phone}
              onChange={handleInputChange}
              style={styles.input}
            />
            <input
              type="number"
              name="people"
              placeholder="No. of People"
              value={formData.people}
              onChange={handleInputChange}
              style={styles.input}
            />
            {/* <input
              type="number"
              name="durationMinutes"
              placeholder="Duration (Minutes)"
              value={formData.durationMinutes}
              onChange={handleInputChange}
              style={styles.input}
            /> */}

            {/* <button
              style={styles.confirmButton}
              onClick={handleConfirmBooking}
            >
              Confirm
            </button>
            <button
              style={styles.cancelButton}
              onClick={() => setShowBookingModal(false)}
            >
              Cancel
            </button> */}
             <div style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "20px",      // space between buttons
              marginTop: "20px"
            }}>
              <button style={styles.confirmButton} onClick={handleConfirmBooking}>
                Confirm
              </button>

              <button
                style={styles.cancelButton}
                onClick={() => setShowBookingModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add/Edit Items Modal */}
      {showItemModal && (
        <div style={styles.overlay}>
          <div style={styles.popup}>
            <h3>Manage Items</h3>
            <input
              type="text"
              placeholder="Item name"
              value={newItem}
              onChange={(e) => setNewItem(e.target.value)}
              style={styles.input}
            />
            <button onClick={handleAddItem} style={styles.itemBtn}>Add</button>
            <ul>
              {bookings[currentItemBookingIndex]?.items.map((item, i) => (
                <li key={i}>
                  {item}
                  <button
                    style={styles.removeItem}
                    onClick={() => handleRemoveItem(i)}
                  >
                    ❌
                  </button>
                </li>
              ))}
            </ul>
            <button onClick={() => setShowItemModal(false)} style={styles.closeBtn}>
              Done
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
const tableHeaderStyle = {
  border: "1px solid #ddd",
  textAlign: "center",
  fontWeight: "bold",
  backgroundColor: "#ee6521",
  color: "white",
  padding: 6,
  minWidth: '100px'
};

const tableCellStyle = {
  border: "1px solid #ddd",
  textAlign: "center",
  padding: 6,
};

const styles = {
  container: {
    padding: "30px",
    marginTop: "50px",
    fontFamily: "Arial",
    margin: "10px",
    height: "700px",
    // overflow: "auto",          // allow scrolling
    // msOverflowStyle: "none",   // IE, Edge
    // scrollbarWidth: "none",    // Firefox

  },

  buttonWrapper: {
    display: "flex",
    justifyContent: "center",
    marginTop: "0px",
    gap: "15px",
    marginBottom: "20px",
  },
  button: {
    padding: "10px",
    backgroundColor: "#4CAF50",
    color: "white",
    fontSize: window.innerWidth <= 768 ? "14px" : "16px", // Smaller font on mobile
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "10px",
    overflowX: "auto",          // Add horizontal scroll only to table
    msOverflowStyle: "none",    // Move these to table
    scrollbarWidth: "none",

  },
  itemBtn: {
    padding: "5px 10px",
    margin: "8px 0",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  input: {
    width: "100%",
    padding: "10px",
    margin: "8px 0",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  confirmButton: {
    width: "100%",
    padding: "10px",
    backgroundColor: "#28a745",
    color: "#fff",
    fontWeight: "bold",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "10px",
  },
  cancelButton: {
    marginTop: "10px",
    backgroundColor: "#dc3545",
    color: "#fff",
    padding: "8px 16px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    width: "100%",
  },
  removeItem: {
    marginLeft: "10px",
    backgroundColor: "transparent",
    color: "red",
    border: "none",
    cursor: "pointer",
  },
  popup: {
    background: "#fff",
    padding: "25px",
    borderRadius: "10px",
    width: "550px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
    textAlign: "left",


  },
  overlay: {
    position: "fixed",
    top: "26%",
    left: "20px",
    width: "90vw",
    height: "60vh",
    // background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999,
  },
  closeBtn: {
    marginTop: "10px",
    backgroundColor: "#6c757d",
    color: "#fff",
    padding: "8px 16px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    width: "100%",
  },

};

export default BookingScreen;
